import { View, Text } from "react-native";
import { semanticColors, typography } from "../theme/tokens";

type StatusTone = keyof typeof semanticColors.status;

type Props = {
  label: string;
  color?: string;
  tone?: StatusTone;
  showDot?: boolean;
};

export function StatusIndicator({
  label,
  color,
  tone = "neutral",
  showDot = true,
}: Props) {
  const resolvedColor = color ?? semanticColors.status[tone];

  return (
    <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
      {showDot && (
        <View
          style={{
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: resolvedColor,
          }}
        />
      )}
      <Text
        style={{
          fontFamily: typography.families.sansMedium,
          fontSize: typography.sizes.sm,
          color: resolvedColor,
        }}
      >
        {label}
      </Text>
    </View>
  );
}
